import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrganisationPickerPage } from 'src/app/modals/organisation-picker/organisation-picker.page';

const routes: Routes = [
  {
    path: '',
    component: OrganisationPickerPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrganisationPickerPage]
})
export class OrganisationPickerPageModule {}
